export default __webpack_public_path__ + "static/media/jp1.022adffb.jpg";